function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M23.64,17.11A3.13,3.13,0,0,0,20.26,16l-3.82,1.27A1.44,1.44,0,0,0,14.88,16H12a7,7,0,0,0-4.65-2H4.75v-.62A.38.38,0,0,0,4.38,13h-4a.38.38,0,0,0-.38.38v8a.38.38,0,0,0,.38.37h4a.38.38,0,0,0,.37-.37v-1c.91.3,1.71.58,2.42.83,2.6.9,4.05,1.39,5.37,1.39,1.61,0,3-.73,6.09-2.36,1.28-.68,2.88-1.53,4.91-2.55a.38.38,0,0,0,.21-.27A.41.41,0,0,0,23.64,17.11ZM4,21H.75V13.75H4ZM18.28,19.6c-5.34,2.84-5.34,2.84-10.86.92-.77-.27-1.66-.58-2.67-.91V14.75H7.38a6.24,6.24,0,0,1,4.23,1.89.39.39,0,0,0,.27.11h3c.56,0,.82.31.82.63a.56.56,0,0,1-.19.41.87.87,0,0,1-.63.21H9.38a.38.38,0,1,0,0,.75h5.5a1.57,1.57,0,0,0,1.3-.59l4.3-1.42a2.19,2.19,0,0,1,2.24.54C20.91,18.2,19.46,19,18.28,19.6Zm-.9-12.85A3.38,3.38,0,1,0,14,3.38,3.37,3.37,0,0,0,17.38,6.75Zm0-6a2.63,2.63,0,1,1-2.63,2.63A2.63,2.63,0,0,1,17.38.75Zm-5,13A3.38,3.38,0,1,0,9,10.38,3.37,3.37,0,0,0,12.38,13.75Zm0-6a2.63,2.63,0,1,1-2.63,2.63A2.63,2.63,0,0,1,12.38,7.75ZM12,11.38v-2a.38.38,0,1,1,.75,0v2a.38.38,0,0,1-.75,0Zm5-7v-2a.38.38,0,1,1,.75,0v2a.38.38,0,0,1-.75,0Z"
})));

var SvgHandMoney = function SvgHandMoney(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.75 22.63",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHandMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hand-money.d6805ee9.svg";
export { ForwardRef as ReactComponent };